module.exports = __webpack_public_path__ + "img/ban2.977914dc.jpg";